import { DataConfig } from '@iotize/tap/config/schema/v1';
import { VariableType } from '@iotize/tap/service/impl/variable';

import {
  TapBundleConfig,
  TapVariableConfig,
} from '../target-variable/tap-bundle/tap-bundle';
import { KeyTypeType } from '../utility/editable-data-stream';
import { getConverterFromVariableConfig } from '../utility/type-converter-factory';
import {
  BundlesConfig,
  TapDataManagerConfig,
} from './create-data-manager-from-tap-config';

export function createDataManagerConfigFromTapDataConfig<DataType>(
  config: DataConfig,
): TapDataManagerConfig<DataType> {
  const bundles = config?.bundles?.reduce<Partial<BundlesConfig<DataType>>>(
    (acc, bundle) => {
      const bundleName = (bundle.name || bundle.id) as keyof DataType;

      const variablesConfig = bundle.variables?.reduce<
        Record<KeyTypeType, TapVariableConfig<any>>
      >((acc, v) => {
        const variableName =
          (typeof v.meta === 'object' ? v.meta.name : v.id) || v.id;
        acc[variableName] = {
          id: v.id,
          dataType: VariableType.Data[
            v.dataType
          ] as unknown as VariableType.Data,
          length: v.length || 1,
          converter: getConverterFromVariableConfig(v),
        };
        return acc;
      }, {});
      const bundleConfig: TapBundleConfig<KeyTypeType> = {
        id: bundle.id,
        variables: variablesConfig || {},
      };
      acc[bundleName] = bundleConfig;
      return acc;
    },
    {},
  ) as BundlesConfig<DataType>;
  return {
    bundles,
  };
}
